//@flow

import React from 'react';

import { type Topping, Toppings } from './domain/pizza';
import Bacon from '../../../../assets/images/pages/pizza/fields/pizza_topping_bacon@3x.png';
import BellPeeper from '../../../../assets/images/pages/pizza/fields/pizza_topping_pman@3x.png';
import Chicken from '../../../../assets/images/pages/pizza/fields/pizza_topping_chicken@3x.png';
import Corn from '../../../../assets/images/pages/pizza/fields/pizza_topping_corn@3x.png';
import Crab from '../../../../assets/images/pages/pizza/fields/pizza_topping_kani@3x.png';
import Salami from '../../../../assets/images/pages/pizza/fields/pizza_topping_salami@3x.png';
import Shrimp from '../../../../assets/images/pages/pizza/fields/pizza_topping_ebi@3x.png';
import Squid from '../../../../assets/images/pages/pizza/fields/pizza_topping_ika@3x.png';
import Tomato from '../../../../assets/images/pages/pizza/fields/pizza_topping_tomato@3x.png';

type Props = {
  topping: Topping,
};

class PizzaTopping extends React.PureComponent<Props> {
  get imgSrc(): string {
    switch (this.props.topping) {
      case Toppings.bell_peeper:
        return BellPeeper;
      case Toppings.tomato:
        return Tomato;
      case Toppings.corn:
        return Corn;
      case Toppings.salami:
        return Salami;
      case Toppings.bacon:
        return Bacon;
      case Toppings.teriyaki_chicken:
        return Chicken;
      case Toppings.crab:
        return Crab;
      case Toppings.squid:
        return Squid;
      case Toppings.shrimp:
        return Shrimp;
      default:
        throw new Error(`Unknown toppings ${this.props.topping.topping}`);
    }
  }
  render() {
    // eslint-disable-next-line
    const { topping, ...rest } = this.props;
    return (
      <div {...rest} className="pizza-image pizza-topping">
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
        <img className="pizza-image pizza-topping-part" src={this.imgSrc} />
      </div>
    );
  }
}

export default PizzaTopping;
